var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.8 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.48.64h.32V0H1.6A1.59,1.59,0,0,0,0,1.6V14.08A1.92,1.92,0,0,0,1.92,16H12.8V2.56h-.32a1,1,0,0,1,0-1.92ZM9.94,6.78a36.26,36.26,0,0,0-3.67,5c-.41.65-.8,1.32-1.2,2L2.21,9.67,2.85,9,5,10.6c.3-.38.59-.75.9-1.11A21.68,21.68,0,0,1,10,5.7a.67.67,0,0,1,.44-.14c.23,0,.46,0,.75,0C10.73,6,10.32,6.37,9.94,6.78ZM11.2,2.56H1.6A1,1,0,0,1,1.6.64h9.6a2,2,0,0,0-.32.94A2.18,2.18,0,0,0,11.2,2.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublish);
export default __webpack_public_path__ + "static/media/icon-publish.961b4ec4b6997bdd2709e897d79e67d8.svg";
export { ForwardRef as ReactComponent };